// extracted by mini-css-extract-plugin
module.exports = {"wrap":"BackToTop_wrap__2OI8e","inner":"BackToTop_inner__a0enR"};